"use client";

import React from "react";
import { Button, EmptyState, Badge } from "@west-tennessee-consulting/ui";
import { HardDrive, ExternalLink } from "lucide-react";

interface DriveListViewProps {
  drives: any[];
  onDriveSelect: (drive: any) => void;
}

export function DriveListView({ drives, onDriveSelect }: DriveListViewProps) {
  if (drives.length === 0) {
    return (
      <EmptyState
        icon={HardDrive}
        title="No Shared Drives"
        description="You don't have access to any shared drives"
      />
    );
  }

  return (
    <div className="space-y-2">
      {drives.map((drive) => (
        <div
          key={drive.id}
          className="flex items-center justify-between p-3 sm:p-4 border rounded-lg hover:bg-muted/50 transition-colors cursor-pointer"
          onClick={() => onDriveSelect(drive)}
        >
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <HardDrive className="h-4 w-4 sm:h-5 sm:w-5 text-blue-500 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="font-medium text-sm sm:text-base truncate">{drive.name}</div>
              <div className="text-xs text-muted-foreground">
                Created {new Date(drive.createdTime).toLocaleDateString()}
              </div>
            </div>
          </div>
          <Button variant="ghost" size="sm" className="p-1 sm:p-2 flex-shrink-0">
            <ExternalLink className="h-3 w-3 sm:h-4 sm:w-4" />
          </Button>
        </div>
      ))}
    </div>
  );
}
